export const getUsuarioFromSession = (sessionResponse) => (
  sessionResponse?.data?.user
  ?? sessionResponse?.data?.usuario
  ?? sessionResponse?.user
  ?? sessionResponse?.usuario
  ?? sessionResponse
)

export const getApplicationsFromSession = (sessionResponse) => (
  sessionResponse?.data?.applications
  ?? sessionResponse?.applications
  ?? []
)

export const getApplicationCode = (applicationAccess) => (
  applicationAccess?.application?.code
  ?? applicationAccess?.applicationCode
  ?? applicationAccess?.code
  ?? ''
)

export const getApplicationAccess = (sessionResponse, applicationCode) => (
  getApplicationsFromSession(sessionResponse).find((applicationAccess) => (
    String(getApplicationCode(applicationAccess)).toUpperCase()
    === String(applicationCode || '').toUpperCase()
  ))
)

export const getPermisosAplicacion = (sessionResponse, applicationCode) => (
  getApplicationAccess(sessionResponse, applicationCode)?.permissions || []
)

export const tienePermiso = (sessionResponse, applicationCode, permissionCode) => (
  getPermisosAplicacion(sessionResponse, applicationCode).includes(permissionCode)
)

export const getQualityCapabilities = (session) => {
  const permissions = getPermisosAplicacion(session, 'QUALITY_PRODUCTION')
  return {
    canRead: permissions.includes('QUALITY_PRODUCTION_READ'),
    canWrite: permissions.includes('QUALITY_PRODUCTION_WRITE'),
    canReview: permissions.includes('QUALITY_PRODUCTION_REVIEW'),
    canAdmin: permissions.includes('QUALITY_PRODUCTION_ADMIN'),
    canUpload: permissions.includes('FILES_WRITE'),
  }
}

export const puedeVerPanelAdmin = (sessionResponse) => (
  Boolean(getApplicationAccess(sessionResponse, 'SUITE_ADMIN'))
)
